import { ActualParameter } from './actual-parameter';
import { ProcessDeUtil } from '../process-de-util';

export class BizComponentEntity {
    constructor(name?: string, metadataid?: string, method?: string) {
        this.id = ProcessDeUtil.GenerateElementId();
        this.name = name;
        this.metadataId = metadataid;
        this.methodCode = method;
        this.isForCompensation = false;
    }
    id: string;
    name: string;
    flowFormKey?: string;
    bizActivityId?: string;
    componentLocation?: ComponentLocation;
    executionTime: string;
    metadataId: string;
    methodCode: string;
    methodName?: string;
    actualParameters: Array<ActualParameter>;
    owner: string;
    ownerType: OwnerType;
    isForCompensation?: boolean;
    condition?: string;
    scopeType?: string;
}
export enum ComponentLocation {
    Process = 0,
    Activity = 1
}
export enum OwnerType {
    Process = 'Process',
    Activity = 'Activity',
    Schema = 'Schema'
}
